(() => {
  const root = document.querySelector('[data-sw-character-finder]');
  if (!root) return;
  const form = root.querySelector('[data-sw-controls]');
  const grid = root.querySelector('[data-sw-grid]');
  const status = root.querySelector('[data-sw-status]');
  const pages = root.querySelector('[data-sw-pages]');
  const strings = JSON.parse(root.querySelector('[data-sw-strings]').textContent);
  const packMembers = {"42883117023403":["Jett","Dizzy","Donnie","Mira","Astra","Paul"],"42883093299371":["Jett","Dizzy","Donnie","Mira","Astra","Paul"],"42982526091435":["Jett","Dizzy","Donnie","Paul"],"42982542573739":["Tino","Lime","Tony"],"42906449608875":["Jett","Dizzy","Golden Boy","Tino"],"42906696286379":["Marc","Golden Wheels"]};
  const namesFrom = value => value.split('|').map(item => item.trim()).filter(Boolean);
  const namesIn = (title, names) => {
    const text = title.toLowerCase().replace(/dizyy/g, 'dizzy').replace(/\bgolden wheel\b/g, 'golden wheels');
    return names.filter(name => {
      if (name === 'Golden Boy' && /\b(?:black|dark) golden boy\b/.test(text)) return false;
      if (name === 'Black Golden Boy') return /\b(?:black|dark) golden boy\b/.test(text);
      const escaped = name.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp('(^|[^a-z])' + escaped + '($|[^a-z])').test(text);
    });
  };
  const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' });
  const money = cents => format.format(cents / 100);
  const fill = (text, values) => Object.entries(values).reduce((value, [key, replacement]) => value.replaceAll('__' + key + '__', replacement), text);
  let products = JSON.parse(root.querySelector('[data-sw-products]').textContent);
  let allNames = [];
  let ready = false;
  const read = () => {
    const params = new URL(window.location.href).searchParams;
    const requested = params.get('sw_character') || '';
    const character = allNames.find(name => name.toLowerCase() === requested.toLowerCase()) || requested;
    return { character, price: params.get('sw_price') || '', available: params.get('sw_available') === '1', sort: params.get('sw_sort') || 'best-selling', page: Math.max(1, parseInt(params.get('sw_page') || '1', 10) || 1) };
  };
  const write = (state, replace = false) => {
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    url.searchParams.set('view', 'characters');
    url.searchParams.set('sort_by', 'best-selling');
    const values = { sw_character: state.character, sw_price: state.price, sw_available: state.available ? '1' : '', sw_sort: state.sort === 'best-selling' ? '' : state.sort, sw_page: state.page > 1 ? String(state.page) : '' };
    Object.entries(values).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
    window.history[replace ? 'replaceState' : 'pushState']({}, '', url);
  };
  const variantNames = (product, variant) => {
    if (product.variants.length === 1) return product.names;
    if (packMembers[variant.id]) return packMembers[variant.id];
    return namesIn(variant.title, product.names);
  };
  const priceFits = (price, bucket) => !bucket || (bucket === 'under25' && price < 2500) || (bucket === '25to50' && price >= 2500 && price <= 5000) || (bucket === 'over50' && price >= 5000);
  const render = () => {
    if (!ready) return;
    const state = read();
    if (state.character && ![...form.elements.sw_character.options].some(option => option.value === state.character)) form.elements.sw_character.add(new Option(state.character, state.character));
    form.elements.sw_character.value = state.character;
    form.elements.sw_price.value = state.price;
    form.elements.sw_available.checked = state.available;
    form.elements.sw_sort.value = state.sort;
    let matches = products.map((product, rank) => {
      const variants = product.variants.filter(variant => (!state.character || variantNames(product, variant).includes(state.character)) && (!state.available || variant.available) && priceFits(variant.price, state.price));
      if (!variants.length) return null;
      const sorted = [...variants].sort((a, b) => a.price - b.price);
      return { product, rank, variants: sorted, min: sorted[0].price, max: sorted[sorted.length - 1].price };
    }).filter(Boolean);
    if (state.sort === 'price-ascending') matches.sort((a, b) => a.min - b.min || a.rank - b.rank);
    else if (state.sort === 'price-descending') matches.sort((a, b) => b.min - a.min || a.rank - b.rank);
    else if (state.sort === 'title-ascending') matches.sort((a, b) => a.product.title.localeCompare(b.product.title));
    const pageCount = Math.max(1, Math.ceil(matches.length / 24));
    if (state.page > pageCount) { state.page = pageCount; write(state, true); }
    const fragment = document.createDocumentFragment();
    matches.slice((state.page - 1) * 24, state.page * 24).forEach(({ product, variants, min, max }) => {
      const variant = variants[0];
      const card = root.querySelector('[data-sw-card-template]').content.cloneNode(true);
      const item = card.querySelector('li');
      item.dataset.productId = product.id;
      item.dataset.matchingCharacters = product.names.join('|');
      const link = card.querySelector('[data-sw-product-link]');
      const url = new URL(product.url, window.location.origin);
      if (state.character) url.searchParams.set('variant', variant.id);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      link.href = url.href;
      if (variant.image || product.image) {
        const img = document.createElement('img');
        img.src = variant.image || product.image;
        img.alt = product.title;
        img.width = 540;
        img.height = 540;
        img.loading = 'lazy';
        img.decoding = 'async';
        card.querySelector('[data-sw-image]').append(img);
      }
      card.querySelector('[data-sw-title]').textContent = product.title;
      card.querySelector('[data-sw-price]').textContent = (max > min ? strings.from + ' ' : '') + money(min);
      card.querySelector('[data-sw-option]').textContent = (state.character && variant.title !== 'Default Title' ? variant.title : product.names.join(' · ')) + (!variant.available ? ' · ' + strings.unavailable : '');
      fragment.append(card);
    });
    grid.replaceChildren(fragment);
    status.textContent = matches.length ? fill(strings.count, { count: matches.length, total: products.length }) : strings.empty;
    root.dataset.matchCount = String(matches.length);
    pages.hidden = pageCount < 2;
    pages.querySelector('[data-sw-page]').textContent = fill(strings.page, { page: state.page, pages: pageCount });
    pages.querySelector('[data-sw-prev]').disabled = state.page <= 1;
    pages.querySelector('[data-sw-next]').disabled = state.page >= pageCount;
  };
  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('change', () => {
    const state = { character: form.elements.sw_character.value, price: form.elements.sw_price.value, available: form.elements.sw_available.checked, sort: form.elements.sw_sort.value, page: 1 };
    write(state); render();
  });
  form.addEventListener('reset', event => { event.preventDefault(); write({ character: '', price: '', available: false, sort: 'best-selling', page: 1 }); render(); });
  pages.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || button.disabled) return;
    const state = read();
    state.page += button.hasAttribute('data-sw-next') ? 1 : -1;
    write(state); render();
    root.querySelector('#sw-character-results').focus();
    root.querySelector('#sw-character-results').scrollIntoView({ block: 'start' });
  });
  window.addEventListener('popstate', render);
  const load = async () => {
    try {
      let next = root.dataset.next;
      const visited = new Set();
      while (next) {
        const url = new URL(next, window.location.origin);
        if (visited.has(url.href)) throw new Error('Repeated catalog page');
        visited.add(url.href);
        url.searchParams.set('view', 'characters');
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Catalog could not load');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('[data-sw-character-finder]');
        if (!section) throw new Error('Missing catalog page');
        products.push(...JSON.parse(section.querySelector('[data-sw-products]').textContent));
        next = section.dataset.next;
      }
      products = [...new Map(products.map(product => [product.id, product])).values()];
      if (products.length !== Number(root.dataset.total)) throw new Error('Incomplete catalog');
      allNames = [...new Set(products.flatMap(product => namesFrom(product.characters)))].sort((a, b) => a.localeCompare(b));
      products.forEach(product => {
        product.names = [...new Set([...namesFrom(product.characters), ...product.variants.flatMap(variant => namesIn(variant.title, allNames))])];
      });
      allNames.forEach(name => form.elements.sw_character.add(new Option(name, name)));
      ready = true; form.hidden = false; render();
    } catch (error) { status.textContent = strings.error; }
  };
  load();
})();
